import React, { useEffect, useState } from "react";

const getPageNumbers = (page, pageCount) => {
  const delta = 1;
  const range = [];
  const withDots = [];
  let last;

  for (let i = 1; i <= pageCount; i++) {
    if (i === 1 || i === pageCount || (i >= page - delta && i <= page + delta)) {
      range.push(i);
    }
  }

  range.forEach((i) => {
    if (last) {
      if (i - last === 2) withDots.push(last + 1);
      else if (i - last !== 1) withDots.push("...");
    }
    withDots.push(i);
    last = i;
  });

  return withDots;
};

const Pagination = ({ page, pageCount, onChange }) => {
  const [goTo, setGoTo] = useState(page);

  useEffect(() => {
    setGoTo(page);
  }, [page]);

  if (!pageCount || pageCount <= 1) return null;

  const goToPage = (p) => {
    const clamped = Math.min(Math.max(1, p), pageCount);
    if (clamped !== page) onChange(clamped);
  };

  const handleGoToSubmit = (e) => {
    e.preventDefault();
    goToPage(Number(goTo) || 1);
  };

  return (
    <div
      className="pagination-bar d-flex align-items-center justify-content-center flex-wrap"
      style={{ gap: "0.75em" }}
    >
      <ul className="pagination justify-content-center mb-0">
        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
          <a
            href="#"
            className="page-link"
            onClick={(e) => {
              e.preventDefault();
              goToPage(page - 1);
            }}
          >
            Prev
          </a>
        </li>
        {getPageNumbers(page, pageCount).map((p, idx) =>
          p === "..." ? (
            <li key={`dots-${idx}`} className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          ) : (
            <li key={p} className={`page-item ${p === page ? "active" : ""}`}>
              <a
                href="#"
                className="page-link"
                onClick={(e) => {
                  e.preventDefault();
                  goToPage(p);
                }}
              >
                {p}
              </a>
            </li>
          )
        )}
        <li className={`page-item ${page === pageCount ? "disabled" : ""}`}>
          <a
            href="#"
            className="page-link"
            onClick={(e) => {
              e.preventDefault();
              goToPage(page + 1);
            }}
          >
            Next
          </a>
        </li>
      </ul>
      <form
        className="d-flex align-items-center"
        style={{ gap: "0.4em" }}
        onSubmit={handleGoToSubmit}
      >
        <span className="text-nowrap">
          Page {page} of {pageCount}
        </span>
        <input
          type="number"
          min={1}
          max={pageCount}
          value={goTo}
          onChange={(e) => setGoTo(e.target.value)}
          className="form-control form-control-sm"
          style={{ width: "70px" }}
        />
        <button type="submit" className="btn btn-sm btn-outline-primary">
          Go
        </button>
      </form>
    </div>
  );
};

export default Pagination;
